import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import Responsive from "datatables.net-responsive-dt";
import "../../dataTables.dataTables.min.css";
import "../../responsive.dataTables.min.css";
import FixedHeader from "datatables.net-fixedheader-dt";
import FixedColumns from "datatables.net-fixedcolumns-dt";
DataTable.use(DT, Responsive, FixedHeader, FixedColumns);

function DataTableComponent({ className, columns, data, options }) {
  return (
    <div className={className}>
      <DataTable data={data} className="display" options={options}>
        <thead>
          <tr>
            {columns?.map((column, idx) => (
              <th key={idx}>{column}</th>
            ))}
          </tr>
        </thead>
      </DataTable>
    </div>
  );
}

export default DataTableComponent;
